module.exports = __webpack_public_path__ + "img/logo-english.c0fa81b2.png";